export const relicNeedStarMap: Record<string, number> = {
  normal: 100,
  race: 200,
  epic: 500,
  legend: 1000,
  antiquity: 2000,
}
